const actions = {
	INIT_AVAILABLEASSETS_SERVERS: 'INIT_AVAILABLEASSETS_SERVERS',
	initServers: () => ({
		type: actions.INIT_AVAILABLEASSETS_SERVERS,
	}),
};

export default actions;
